import { createStyles, makeStyles, Theme } from '@material-ui/core';

const MediaExportTabStyles = makeStyles(({ palette }: Theme) => createStyles({
  row: {
    border: `solid 1px ${palette.table.border}`,
    padding: 10,
  },
  title: {
    fontWeight: 'bold',
  },
  actionContainer: {
    marginLeft: 'auto',
  },
  groupAction: {
    background: 'unset',
    border: 'solid 1px #018694',
    color: '#018694',
    '& span': {
      fontSize: 14,
    },
  },
}), { name: 'MediaExportTabStyles' });

export default MediaExportTabStyles;
